import React from 'react'
import { Grid, Row, Col, Placeholder, Panel } from 'rsuite'

export default function ProblemsAndSolutionView(props) {
  const { Graph } = Placeholder
  const { schema } = props
  const paragraph = <>&nbsp; &nbsp; &nbsp;</>
  const emptyData = (
    <>
      <Graph height={9} width={'95%'} style={{ marginLeft: '5%' }} />
      <Graph height={9} />
      <Graph height={9} />
      <Graph height={9} />
    </>
  )

  return (
    <Panel>
      <Grid fluid>
        {schema.isProblemsEncountered.value == 1 ? (
          <Row>
            <Col style={{ marginTop: 5 }}>
              <b>{schema.problems.label}</b>

              {schema.problems.value ? (
                // <p>
                //   {paragraph}
                //   {schema.problems.value}
                // </p>
                <div
                  style={{ paddingLeft: 15 }}
                  dangerouslySetInnerHTML={{ __html: `${schema.problems.value}` }}
                />
              ) : (
                emptyData
              )}
            </Col>
            <Col style={{ marginTop: 5 }}>
              <b>{schema.solutions.label}</b>
              {schema.solutions.value ? (
                // <p>
                //   {paragraph}
                //   {schema.solutions.value}
                // </p>
                <div
                  style={{ paddingLeft: 15 }}
                  dangerouslySetInnerHTML={{ __html: `${schema.solutions.value}` }}
                />
              ) : (
                emptyData
              )}
            </Col>
          </Row>
        ) : (
          <Row>
            {schema.isProblemsEncountered.options?.map((item) => {
              if (item.value == schema.isProblemsEncountered.value) {
                return item.label
              }
            })}
          </Row>
        )}
      </Grid>
    </Panel>
  )
}
